const cartLoadingBar = {
  expressDelivery: 'Express delivery service',
  regularDelivery: 'Error service with appointment',
  expressDelivery2: 'Express Delivery Service',
  regularDelivery2: 'Delivery service',
  free: 'Free',
  regularDeliveryFor: 'Delivery service for {deliveryPrice}',
  expressDeliveryFor: 'Express delivery service for {deliveryPrice}',
  moreToThreshold: '{amount} more',
  deliveryByAgreement: 'Delivery by agreement',
}

export default cartLoadingBar
